import { TextLarge, TextMedium } from "../Typography";
import NotFoundImg from "~/assets/not-found.png";
import { useTranslation } from "react-i18next";
import { Link } from "../Link";

export const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <img className="w-1/4 max-w-xs" alt="" src={NotFoundImg} />
      <TextLarge className="mb-5 mt-12 text-[40px] font-bold leading-[52px] text-[#072236]">
        {t("webapp.404.title", "404")}
      </TextLarge>

      <TextMedium className="text-center text-[18px] text-[#183B56]">
        {t(
          "webapp.404.not_exist",
          "The page you are looking for doesn't exist"
        )}
      </TextMedium>

      <Link className="mt-4" to="/">
        {t("webapp.404.home", "Home")}
      </Link>
    </div>
  );
};
